import { toast } from "sonner";
import {
  toastAdded,
  toastRequestSent,
  toastSaved,
  toastUpdated,
} from "./mutation-toast";

/**
 * Desk action feedback — plan/27 + plan/38.
 * Pair with field / section helpers for validation; toast for outcomes the
 * user may miss while scrolled away. Skip on POS Floor (use chips there).
 */
export const notify = {
  success(message: string) {
    toast.success(message, { duration: 3200 });
  },
  error(message: string) {
    toast.error(message, { duration: 5200 });
  },
  /** Queued / informational — not a failure */
  info(message: string) {
    toast.message(message, { duration: 4200 });
  },
  /** New row created */
  added(subject: string) {
    toast.success(toastAdded(subject), { duration: 3200 });
  },
  /** New row created (alternate wording) */
  saved(subject: string) {
    toast.success(toastSaved(subject), { duration: 3200 });
  },
  /** Sparse PATCH applied */
  updated(subject: string) {
    toast.success(toastUpdated(subject), { duration: 3200 });
  },
  /** Gated update queued as change request */
  requestSent(subject?: string) {
    toast.message(toastRequestSent(subject), { duration: 4200 });
  },
};
